var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "video-thumbnail" },
    [
      _c("div", { staticClass: "video-thumbnail__button-wrapper" }, [
        _c(
          "button",
          {
            staticClass: "u-clear-button video-thumbnail__button",
            attrs: { tabindex: _vm.tabIndex },
            on: { focus: _vm.focused, click: _vm.openVideo },
          },
          [
            _c("div", {
              staticClass: "video-thumbnail__overlay",
              style: _vm.overlayStyle,
            }),
            _vm.$mq === "mobile"
              ? _c("img", { attrs: { src: _vm.mobileImage, alt: _vm.alt } })
              : _c("img", { attrs: { src: _vm.image, alt: _vm.alt } }),
            _c("icon", {
              attrs: { name: "play", size: "72px", label: "Play" },
            }),
          ],
          1
        ),
      ]),
      _c("transition", { attrs: { name: "fade-slow" } }, [
        _vm.showDescription
          ? _c("div", { staticClass: "video-thumbnail__description" }, [
              _vm._v(_vm._s(_vm.description)),
            ])
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }